export const Manufacturing = [
  {
    id: 2,
    img: "./images/manufacturing/02.jpg",
    name: "Manufacturing Image 2",
  },
  {
    id: 3,
    img: "./images/manufacturing/03.jpg",
    name: "Manufacturing Image 3",
  },
  {
    id: 4,
    img: "./images/manufacturing/04.jpg",
    name: "Manufacturing Image 4",
  },
  {
    id: 5,
    img: "./images/manufacturing/05.jpg",
    name: "Manufacturing Image 5",
  },

  {
    id: 7,
    img: "./images/manufacturing/07.jpg",
    name: "Manufacturing Image 7",
  },
  {
    id: 8,
    img: "./images/manufacturing/08.jpg",
    name: "Manufacturing Image 8",
  },

  {
    id: 11,
    img: "./images/manufacturing/11.jpg",
    name: "Manufacturing Image 11",
  },

  {
    id: 13,
    img: "./images/manufacturing/13.jpg",
    name: "Manufacturing Image 13",
  },
  {
    id: 14,
    img: "./images/manufacturing/14.jpg",
    name: "Manufacturing Image 14",
  },

  {
    id: 16,
    img: "./images/manufacturing/16.jpg",
    name: "Manufacturing Image 15",
  },
];

export const Celebration = [
  { id: 1, img: "./images/celebration/01.jpg", name: "Celebration Image 1" },
  { id: 2, img: "./images/celebration/02.jpg", name: "Celebration Image 2" },
  { id: 3, img: "./images/celebration/03.jpg", name: "Celebration Image 3" },
  { id: 4, img: "./images/celebration/04.jpg", name: "Celebration Image 4" },
  { id: 5, img: "./images/celebration/05.jpg", name: "Celebration Image 5" },
  { id: 6, img: "./images/celebration/06.jpg", name: "Celebration Image 6" },
  { id: 7, img: "./images/celebration/07.jpg", name: "Celebration Image 7" },
  { id: 8, img: "./images/celebration/08.jpg", name: "Celebration Image 8" },
  { id: 9, img: "./images/celebration/09.jpg", name: "Celebration Image 9" },
  { id: 10, img: "./images/celebration/10.jpg", name: "Celebration Image 10" },
  { id: 11, img: "./images/celebration/11.jpg", name: "Celebration Image 11" },
];

export const Events = [
  {
    id: 15,
    img: "./images/events/IMG_20230224_181717-01.jpeg",
    name: "Event Image 15",
  },
  {
    id: 16,
    img: "./images/events/IMG_20230224_182443-01.jpeg",
    name: "Event Image 16",
  },
  {
    id: 17,
    img: "./images/events/IMG_20230224_183528-01.jpeg",
    name: "Event Image 17",
  },
  {
    id: 18,
    img: "./images/events/IMG_20230224_190656-01.jpeg",
    name: "Event Image 18",
  },
  {
    id: 19,
    img: "./images/events/IMG_20230224_192603.jpg",
    name: "Event Image 19",
  },
  {
    id: 20,
    img: "./images/events/IMG_20230224_192606.jpg",
    name: "Event Image 20",
  },
  {
    id: 21,
    img: "./images/events/IMG_20231126_165649.jpg",
    name: "Event Image 21",
  },
  {
    id: 22,
    img: "./images/events/IMG_20231126_172032.jpg",
    name: "Event Image 22",
  },
  {
    id: 23,
    img: "./images/events/IMG_20231126_185517.jpg",
    name: "Event Image 23",
  },
  {
    id: 24,
    img: "./images/events/IMG_20231126_193639.jpg",
    name: "Event Image 24",
  },
  {
    id: 25,
    img: "./images/events/IMG_20231126_200656.jpg",
    name: "Event Image 25",
  },
];
export const Participation = [
  {
    id: 1,
    img: "./images/participation/img1.JPG",
    name: "Participation Image 1",
  },
  {
    id: 2,
    img: "./images/participation/img2.JPG",
    name: "Participation Image 2",
  },
  {
    id: 3,
    img: "./images/participation/img3.JPG",
    name: "Participation Image 3",
  },
  {
    id: 4,
    img: "./images/participation/img4.JPG",
    name: "Participation Image 4",
  },
  {
    id: 5,
    img: "./images/participation/img5.JPG",
    name: "Participation Image 5",
  },
  {
    id: 6,
    img: "./images/participation/img6.JPG",
    name: "Participation Image 6",
  },
  {
    id: 7,
    img: "./images/participation/img7.JPG",
    name: "Participation Image 7",
  },
  {
    id: 8,
    img: "./images/participation/img8.JPG",
    name: "Participation Image 8",
  },
  {
    id: 9,
    img: "./images/participation/img9.JPG",
    name: "Participation Image 9",
  },
  {
    id: 10,
    img: "./images/participation/img10.JPG",
    name: "Participation Image 10",
  },
  {
    id: 11,
    img: "./images/participation/img11.JPG",
    name: "Participation Image 11",
  },
  {
    id: 12,
    img: "./images/participation/img12.JPG",
    name: "Participation Image 12",
  },
  {
    id: 13,
    img: "./images/participation/img13.JPG",
    name: "Participation Image 13",
  },
  {
    id: 14,
    img: "./images/participation/img14.JPG",
    name: "Participation Image 14",
  },
  {
    id: 15,
    img: "./images/participation/img15.JPG",
    name: "Participation Image 15",
  },
  {
    id: 16,
    img: "./images/participation/img16.JPG",
    name: "Participation Image 16",
  },
  {
    id: 17,
    img: "./images/participation/img17.JPG",
    name: "Participation Image 17",
  },
  {
    id: 18,
    img: "./images/participation/img18.JPG",
    name: "Participation Image 18",
  },
  {
    id: 19,
    img: "./images/participation/img19.JPG",
    name: "Participation Image 19",
  },
  {
    id: 20,
    img: "./images/participation/img20.JPG",
    name: "Participation Image 20",
  },
  {
    id: 21,
    img: "./images/participation/img21.JPG",
    name: "Participation Image 21",
  },
  {
    id: 22,
    img: "./images/participation/img22.JPG",
    name: "Participation Image 22",
  },
  {
    id: 23,
    img: "./images/participation/img23.JPG",
    name: "Participation Image 23",
  },
  {
    id: 24,
    img: "./images/participation/img24.JPG",
    name: "Participation Image 24",
  },
  {
    id: 25,
    img: "./images/participation/img25.JPG",
    name: "Participation Image 25",
  },
  {
    id: 26,
    img: "./images/participation/img26.JPG",
    name: "Participation Image 26",
  },
  {
    id: 27,
    img: "./images/participation/img27.JPG",
    name: "Participation Image 27",
  },
  {
    id: 28,
    img: "./images/participation/img28.JPG",
    name: "Participation Image 28",
  },
  {
    id: 29,
    img: "./images/participation/img29.JPG",
    name: "Participation Image 29",
  },
  {
    id: 30,
    img: "./images/participation/img30.JPG",
    name: "Participation Image 30",
  },
  {
    id: 31,
    img: "./images/participation/img31.JPG",
    name: "Participation Image 31",
  },
  {
    id: 32,
    img: "./images/participation/img32.JPG",
    name: "Participation Image 32",
  },
  {
    id: 33,
    img: "./images/participation/img33.JPG",
    name: "Participation Image 33",
  },
  {
    id: 34,
    img: "./images/participation/img34.JPG",
    name: "Participation Image 34",
  },
  {
    id: 35,
    img: "./images/participation/img35.JPG",
    name: "Participation Image 35",
  },
  {
    id: 36,
    img: "./images/participation/img36.JPG",
    name: "Participation Image 36",
  },
  {
    id: 37,
    img: "./images/participation/img37.JPG",
    name: "Participation Image 37",
  },
  {
    id: 38,
    img: "./images/participation/img38.JPG",
    name: "Participation Image 38",
  },
  {
    id: 39,
    img: "./images/participation/img39.JPG",
    name: "Participation Image 39",
  },
  {
    id: 40,
    img: "./images/participation/img40.JPG",
    name: "Participation Image 40",
  },
  {
    id: 41,
    img: "./images/participation/img41.JPG",
    name: "Participation Image 41",
  },
  {
    id: 42,
    img: "./images/participation/img42.JPG",
    name: "Participation Image 42",
  },
  {
    id: 43,
    img: "./images/participation/img43.JPG",
    name: "Participation Image 43",
  },
  {
    id: 44,
    img: "./images/participation/img44.JPG",
    name: "Participation Image 44",
  },
  {
    id: 45,
    img: "./images/participation/img45.JPG",
    name: "Participation Image 45",
  },
  {
    id: 46,
    img: "./images/participation/img46.JPG",
    name: "Participation Image 46",
  },
  {
    id: 47,
    img: "./images/participation/img47.JPG",
    name: "Participation Image 47",
  },
  {
    id: 48,
    img: "./images/participation/img48.JPG",
    name: "Participation Image 48",
  },
  {
    id: 49,
    img: "./images/participation/img49.JPG",
    name: "Participation Image 49",
  },
  {
    id: 50,
    img: "./images/participation/img50.JPG",
    name: "Participation Image 50",
  },
  {
    id: 51,
    img: "./images/participation/img51.JPG",
    name: "Participation Image 51",
  },
  {
    id: 52,
    img: "./images/participation/img52.JPG",
    name: "Participation Image 52",
  },
  {
    id: 53,
    img: "./images/participation/img53.JPG",
    name: "Participation Image 53",
  },
  {
    id: 54,
    img: "./images/participation/img54.JPG",
    name: "Participation Image 54",
  },
  {
    id: 55,
    img: "./images/participation/img55.JPG",
    name: "Participation Image 55",
  },
  {
    id: 56,
    img: "./images/participation/img56.JPG",
    name: "Participation Image 56",
  },
  {
    id: 57,
    img: "./images/participation/img57.JPG",
    name: "Participation Image 57",
  },
  {
    id: 58,
    img: "./images/participation/img58.JPG",
    name: "Participation Image 58",
  },
  {
    id: 59,
    img: "./images/participation/img59.JPG",
    name: "Participation Image 59",
  },
  {
    id: 60,
    img: "./images/participation/img60.JPG",
    name: "Participation Image 60",
  },
  {
    id: 61,
    img: "./images/participation/img61.JPG",
    name: "Participation Image 61",
  },
  {
    id: 62,
    img: "./images/participation/img62.JPG",
    name: "Participation Image 62",
  },
];

export const Group = [
  // { id: 1, img: "./images/events/IMG_3202.JPG", name: "Event Image 1" },
  { id: 2, img: "./images/events/IMG_3207.JPG", name: "Event Image 2" },
  { id: 3, img: "./images/events/IMG_3216.JPG", name: "Event Image 3" },
  { id: 4, img: "./images/events/IMG_3222.JPG", name: "Event Image 4" },
  { id: 5, img: "./images/events/IMG_3227.JPG", name: "Event Image 5" },
  { id: 6, img: "./images/events/IMG_3237.JPG", name: "Event Image 6" },
  { id: 7, img: "./images/events/IMG_3240.JPG", name: "Event Image 7" },
  { id: 8, img: "./images/events/IMG_3246.JPG", name: "Event Image 8" },
  { id: 9, img: "./images/events/IMG_3269.JPG", name: "Event Image 9" },
  { id: 10, img: "./images/events/IMG_3283.JPG", name: "Event Image 10" },
  { id: 11, img: "./images/events/IMG_3294.JPG", name: "Event Image 11" },
  { id: 12, img: "./images/events/IMG_3310.JPG", name: "Event Image 12" },
  // { id: 13, img: "./images/events/IMG_3328.JPG", name: "Event Image 13" },
  // { id: 14, img: "./images/events/IMG_3334.JPG", name: "Event Image 14" },
];
